import { useAtomValue } from 'jotai';
import { dealBoardConfigState } from '../../DealFlow2/state/DealboardDataState';
import { GenericConfigPage } from '../Common/GenericConfigPage';
import { getDealReasonFields } from './DealReasonFields';
import { transformDataModelBeforeSubmit } from './DealReasonUtils';

export function ConfigPassReasons() {
  const { passReasons } = useAtomValue(dealBoardConfigState);

  return (
    <GenericConfigPage
      baseTitle={'Passed Reason'}
      data={passReasons}
      fields={[]}
      formFields={getDealReasonFields()}
      pageTitle={'Passed Reasons'}
      queryURL={'/passReason'}
      transformBeforeSubmit={transformDataModelBeforeSubmit}
    />
  );
}
